import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import QualificationShortInfo from "./QualificationShortInfo";
import { download } from "../../utils/FileDownload";
import { useDispatch, useSelector } from "react-redux";
import { setIsExamLaunched } from "../../store/actions";
import { formatDateRange, getSubjectStatus } from "../../utils/commonFunction";
import CommonCourseComponents from "./CommonCourseComponents";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { generatePdfForCurriculumNew } from "../../services/QualificationService";
import Swal from "sweetalert2";
import { zipURL,ADMIN_PASSWORD, UPLOAD_ROOT_PATH } from "../../utils/Constants";
import { TotalProgressText, ProgressWrapper, ProgressTrack, ProgressFillLearning, ProgressFillAssessment, ProgressFooter, LegendRow, LegendItem, Dot } from "../Program/ProgramStyledComponents";
import { tokens } from "../../public/tokens.js";
import { StandardButton } from "../common/GlobalElements/StandardButton.js";
var $ = require("jquery");

const QualificationHeadBox = (props) => {
  const { row, showProgress, setShowProgress,updateLearningAssessment} = props;
  const [courseData, setCourseData]=useState({})
  const { progress } = courseData || {};
  const {qid, sid}=useParams()
  const history = useHistory();
  const dispatch = useDispatch();
  const { examLaunched } = useSelector(state => state.examLaunched);
  var icon = getSubjectStatus(courseData?.subjectStatus);
  const [bookListFileURL, setBookListFileURL] = useState('')
  const handleSideBar = () => {
    $("body").toggleClass("hide-subject-sidebar");
    if ($("body").hasClass("hide-subject-sidebar")) {
      $("body").removeClass("sub-sidebar-c");
    } else {
      $("body").addClass("sub-sidebar-c");
    }
  };

  useEffect(() => {
    if (row.responseData && Object.keys(row.responseData).length > 0) {
      // Code to execute if row.responseData has keys
      setCourseData(row.responseData)
  }else if (row.qualification && Object.keys(row.qualification).length > 0){
      setCourseData(row.qualification)
    }
  }, [props]);

   // Utility function to ensure the value is a number
  const toFixedOrDefault = (value, decimals = 2) => {
    const num = Number(value);
    return isNaN(num) ? `0` : num
  };

  useEffect(() => {
    if (
      !(progress?.total_assessment > 0 &&
        (progress?.total_documents > 0 ||
        progress?.total_links > 0 ||
        progress?.total_quizs > 0 ||
        progress?.total_videos > 0))
    ) {
      setShowProgress && setShowProgress(true);
      updateLearningAssessment && updateLearningAssessment(true);
    }
  }, [progress]);

  const handleDownloadPrescribedBook = () => {

    const brandVariable = localStorage.getItem("brandVariables");
    const brandId = brandVariable ? JSON.parse(brandVariable).id : null;

    const payload = {
      brandId: brandId,
      netsuite_id: courseData?.netsuite_id
    };

    Swal.fire({
      icon: "info",
      title: "File Downloading...",
      showConfirmButton: "ok",
      onOpen: () => Swal.showLoading(),
    });

    generatePdfForCurriculumNew(payload)
      .then((res) => {
        if (res.data?.fileName !== "") {
          let fileURL = res.data?.fileName;
          fileURL = zipURL !== ""
            ? zipURL + fileURL
              ?.replace(`${UPLOAD_ROOT_PATH}/`, "")
              .replace("public/", "")
              .replace(/https?:\/\//, "")
            : fileURL?.replace(`${UPLOAD_ROOT_PATH}/`, "").replace("public/", "");
          setBookListFileURL(fileURL);
        } else {
          Swal.fire({
            icon: "error",
            title: "Error while downloading file",
            confirmButtonText: "OK",
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Error while downloading file",
          confirmButtonText: "OK",
        });
      })
  };

  useEffect(() => {
    if (!bookListFileURL) return;

    const fileName = bookListFileURL.split("/").pop() || "download.pdf";

    download(bookListFileURL, fileName)
      .catch(() => {
        Swal.fire({
          icon: "error",
          title: "Error while downloading file",
          showConfirmButton: true
        });
      });
  }, [bookListFileURL]);

  const assessment = row.responseData?.progress?.totalAssessmentPercentage || 0;
  const learning = row.responseData?.progress?.totalLearningMaterialPercentage || 0;
  const assessmentOnTop = assessment < learning;

  return (
    <>
      <div className="sub-lft-head">
        <div className="all-courses side__nav__btn">
          {history.location.pathname === examLaunched?.url &&
          examLaunched?.isExamLaunched ? (
            <StandardButton
              as={Link}
              textOnly={true}
              to="#"
              onClick={() =>
                dispatch(
                  setIsExamLaunched({ ...examLaunched, isClicked: true }),
                )
              }
              title="Back"
            >
              <i className="fal fa-angle-left"></i>Back
            </StandardButton>
          ) : (
            <StandardButton
              as={Link}
              fontSize={tokens.typography.fontSize["base-16px"]}
              fontWeight={tokens.typography.fontWeights.regular}
              textOnly={true}
              to={
                props.learningTab
                  ? props.isAdmin === 1
                    ? `/courseinfo/${qid}/subject/${sid}/${ADMIN_PASSWORD}`
                    : `/course/${qid}/subject/${sid}`
                  : sid
                    ? `/mycourses/${qid}`
                    : "/mycourses"
              }
              title="Back"
              onClick={() => {
                if (props.learningTab) {
                  props.setLearningTab(false);
                  props.setshow({
                    cards: true,
                    list: false,
                    desc: false,
                    question: false,
                  });
                }
              }}
            >
              <i className="fal fa-angle-left"></i>Back
            </StandardButton>
          )}
          <button
            className="close-btn-sidebar"
            onClick={handleSideBar}
            title="Close Side Bar"
          >
            <i className="close-bar close-bar-1"></i>
            <i className="close-bar close-bar-2"></i>
            <i className="close-bar close-bar-3"></i>
          </button>
        </div>

        <div className={(props.learningTab && !props.show.cards) ? "couses-bx-info-top-learning" : "couses-bx-info-top"}>
          {(!props.learningTab || (props.learningTab && props.show.cards)) && 
            <>
              <div className="couses-subject-head">
                <CommonCourseComponents degree={(courseData?.program_type_name) ? courseData?.program_type_name : "NA"} />
              </div>

              <div className="couses-bx-info-right">
                <QualificationShortInfo
                  qualification={courseData || row?.qualification}
                />
              </div>
            </>
          }

          {(!props.learningTab || (props.learningTab && props.show.cards)) && (
            <>
              <div className="progress-program-qualification">
                {progress?.total_assessment > 0 &&
                  (progress?.total_documents > 0 ||
                    progress?.total_links > 0 ||
                    progress?.total_quizs > 0 ||
                    progress?.total_videos > 0) && (
                    <div className="programme">
                      <TotalProgressText
                        title={`${toFixedOrDefault(
                          row.responseData?.progress?.progressBar,
                          2
                        )}% Completed`}
                      >
                        {toFixedOrDefault(
                          row.responseData?.progress?.progressBar,
                          2
                        )}% Completed
                      </TotalProgressText>

                      <div>
                        <ProgressWrapper>
                          <ProgressTrack>
                            {assessmentOnTop ? (
                              <ProgressFillLearning
                                style={{
                                  width: `${Math.max(assessment, learning)}%`,
                                }}
                              />
                            ) : (
                              <ProgressFillAssessment
                                style={{
                                  width: `${Math.max(assessment, learning)}%`,
                                }}
                              />
                            )}

                            {assessmentOnTop ? (
                              <ProgressFillAssessment
                                style={{
                                  width: `${Math.min(assessment, learning)}%`,
                                }}
                              />
                            ) : (
                              <ProgressFillLearning
                                style={{
                                  width: `${Math.min(assessment, learning)}%`,
                                }}
                              />
                            )}
                          </ProgressTrack>

                          <ProgressFooter>
                            <LegendRow>
                              <LegendItem>
                                <Dot
                                  style={{
                                    backgroundColor:
                                      tokens.colors.brand["fresh-green"]["700"],
                                  }}
                                />
                                Assessments
                              </LegendItem>

                              <LegendItem>
                                <Dot
                                  style={{
                                    backgroundColor:
                                      tokens.colors.brand["fresh-green"]["400"],
                                  }}
                                />
                                Learning Material
                              </LegendItem>
                            </LegendRow>
                          </ProgressFooter>
                        </ProgressWrapper>
                      </div>
                    </div>
                  )}
              </div>
            </>
          )}
        </div>
        <div className="dlButtonWrapper">
          {(!props.learningTab || (props.learningTab && props.show.cards)) &&
          courseData?.timeTable &&
          courseData?.timeTable !== "" &&
          courseData?.timeTable !== null ? (
            <StandardButton
              outline={true}
              fontSize={tokens.typography.fontSize["md-12px"]}
              fontWeight={tokens.typography.fontWeights.semibold}
              padding="12px 15px"
              variant="transparent"
              title="Download Timetable"
              className="dlBooksBaseButton timetableButton"
              onClick={() => download(courseData?.file, courseData?.fileName)}
            >
              <i className="fal fa-download"></i>Timetable
            </StandardButton>
          ) : null}

          {(!props.learningTab || (props.learningTab && props.show.cards)) &&
          courseData?.prescribed_book_buttton === 1 ? (
            <StandardButton
              outline={true}
              fontSize={tokens.typography.fontSize["md-12px"]}
              fontWeight={tokens.typography.fontWeights.semibold}
              padding="12px 15px"
              variant="transparent"
              title="Download Prescribed Book List"
              onClick={() => {
                handleDownloadPrescribedBook();
              }}
            >
              <i className="fal fa-download"></i>Book List
            </StandardButton>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default QualificationHeadBox;
